export default __webpack_public_path__ + "static/media/1-1-2.50ee6579.webp";